import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const getVerificationColor = (status) => {
  switch (status) {
    case 'verified':
      return 'trust-badge-verified';
    case 'flagged':
      return 'trust-badge-flagged';
    default:
      return 'trust-badge-unverified';
  }
};

export const getVerificationLabel = (status) => {
  switch (status) {
    case 'verified':
      return 'Verified';
    case 'flagged':
      return 'Flagged';
    default:
      return 'Unverified';
  }
};

export const provinces = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'Northern Cape',
  'North West',
  'Western Cape',
];

export const activities = [
  'Hiking',
  'Team building',
  'Archery',
  'Canoeing',
  'Survival skills',
  'Sports',
  'Arts & crafts',
  'Environmental education',
  'Faith-based programmes',
  'Other',
];

export const campTypes = [
  { value: 'outdoor', label: 'Outdoor' },
  { value: 'sports', label: 'Sports Camp' },
  { value: 'academic', label: 'Academic / Educational' },
  { value: 'adventure', label: 'Adventure' },
  { value: 'faith-based', label: 'Faith-based / Retreat' },
  { value: 'environmental', label: 'Environmental' },
  { value: 'glamping', label: 'Glamping' },
  { value: 'day_camp', label: 'Day Camp' },
  { value: 'residential', label: 'Residential' },
  { value: 'wilderness', label: 'Wilderness / Bushcraft' },
  { value: 'arts', label: 'Arts Camp' },
];

export const reviewerRoles = [
  { value: 'parent', label: 'Parent' },
  { value: 'teacher', label: 'Teacher' },
  { value: 'school_admin', label: 'School Administrator' },
  { value: 'other', label: 'Other' },
];

export const verificationStatuses = [
  { value: 'verified', label: 'Verified' },
  { value: 'unverified', label: 'Unverified' },
  { value: 'flagged', label: 'Flagged' },
];

export const ageGroups = ['6-9', '10-12', '13-15', '16-18', '18+'];

export const campRoles = ['facilitator', 'leader', 'medic', 'instructor'];

export const facilitatorSpecialties = [
  'Team Building',
  'Survival Skills',
  'Outdoor Leadership',
  'Water Activities',
  'Hiking & Trekking',
  'Rock Climbing',
  'First Aid Training',
  'Environmental Education',
  'Wildlife & Nature',
  'Arts & Crafts',
  'Sports Coaching',
  'Faith-based Programs',
  'Youth Development',
  'Adventure Racing',
  'Archery',
  'Canoeing & Kayaking',
];

export const firstAidLevels = [
  { value: 'level_1', label: 'Level 1' },
  { value: 'level_2', label: 'Level 2' },
  { value: 'level_3', label: 'Level 3' },
  { value: 'advanced', label: 'Advanced/Wilderness' },
];
